import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Divider,
  Flex,
} from '@chakra-ui/react';
import React, { ReactNode } from 'react';
import Button from '@/components/common/Button';

interface IFormModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  size?: string;
  isCentered?: boolean;
  showCloseButton?: boolean;
  onConfirm?: () => void;
  isLoading?: boolean;
  saveText?: string;
}

const FormModal: React.FC<IFormModalProps> = ({
  saveText = 'Confirm',
  isOpen,
  onClose,
  title,
  children,
  size = 'xl',
  isCentered = true,
  showCloseButton = true,
  onConfirm,
  isLoading = false,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={size} isCentered={isCentered}>
      <ModalOverlay bg="rgba(0, 0, 0, 0.6)" backdropFilter="blur(2px)" />
      <ModalContent
        position="relative"
        bottom={{ base: 'auto', md: 'auto' }}
        left={{ base: 'auto', md: 'auto' }}
      >
        {title && (
          <ModalHeader
            fontSize={'xl'}
            fontWeight={'semibold'}
            fontFamily={'primary'}
            color={'text.primary'}
            bg={'white'}
            borderRadius={'12px 12px 0 0'}
          >
            {title}
          </ModalHeader>
        )}
        {showCloseButton && <ModalCloseButton />}
        {showCloseButton && <Divider borderColor={'border.default'} />}
        <ModalBody
          px={{ base: '16px', lg: '20px' }}
          bg={'background.secondary'}
          minH={'60vh'}
          maxH={'60vh'}
          overflow={'auto'}
        >
          {children}
        </ModalBody>

        <ModalFooter
          justifyContent="space-between"
          borderTop={'1px'}
          borderColor={'border.default'}
        >
          <Flex
            bg={{ base: 'background.tertiary', md: 'background.white' }}
            rounded={{ base: 'lg' }}
            borderColor={'border.default'}
            gap={4}
            justify={'space-between'}
            width={'100%'}
          >
            <Button
              width={{ base: '100%', lg: 'auto' }}
              variant="outline"
              borderWidth={'2px'}
              borderColor={'brand.primary.DEFAULT'}
              onClick={onClose}
              color={'brand.primary.DEFAULT'}
              fontSize={'md'}
              fontWeight={'semibold'}
              borderRadius={'xl'}
              px={6}
              py={'10px'}
            >
              Cancel
            </Button>
            <Button
              width={{ base: '100%', lg: 'auto' }}
              variant={'primary'}
              onClick={onConfirm}
              fontSize={'md'}
              fontWeight={'semibold'}
              borderRadius={'xl'}
              borderWidth={'2px'}
              borderColor={'brand.primary.DEFAULT'}
              px={6}
              py={'10px'}
              type="submit"
              form="form"
              isLoading={isLoading}
            >
              {saveText}
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FormModal;
